export default __webpack_public_path__ + "static/media/about.cb9f6b64.png";